/**
 * Envolve a promise de um endpoint de LISTAGEM (tabela ou dropdown) para que uma
 * resposta HTTP de erro (4xx/5xx) resolva como lista vazia em vez de rejeitar.
 *
 * Motivacao: alguns endpoints (ex.: API de ordem de servico) respondem 500 quando a
 * conta ainda nao possui dados. Para a tela isso significa "nenhum registro", nao falha.
 *
 * - O `status` original e preservado: quem precisar distinguir "vazio" de "falhou"
 *   (ex.: exportacao de CSV) deve checar `response.status`.
 * - Erros SEM resposta do servidor (rede, timeout, cancelamento) continuam rejeitando.
 * - NAO usar em create/update/delete: engolir o erro ali viraria "salvo com sucesso" falso.
 *
 * @param {Promise<import('axios').AxiosResponse>} promise requisicao axios de listagem
 * @param {string} contexto descricao usada no log, ex.: 'ordens de serviço'
 * @returns {Promise<import('axios').AxiosResponse>} resposta original, ou a resposta de erro
 * com `data` substituido por `{ result: [] }`
 */
export const ouListaVazia = (promise, contexto) =>
	promise.catch((error) => {
		if (!error.response) throw error
		console.error(`Erro ao carregar ${contexto}:`, error)
		return { ...error.response, data: { result: [] } }
	})
